import flatpickr from 'flatpickr';
import React, { Fragment, useEffect, useRef } from 'react'
import 'flatpickr/dist/flatpickr.min.css';
import { Input } from '@chakra-ui/react';
import moment from 'moment';
function DateTimePicker({ onDateSelect, defaultValue, minDate }) {
    const inputRef = useRef(null);
    useEffect(() => {
        const options = {
            enableTime: true,
            //dateFormat: 'Y-m-d H:i',
            dafaultDate: defaultValue,
            minDate,
            onChange: (selectedDates, dateStr, instance) => {
                
                const formattedDate = moment(dateStr).format('lll');
                inputRef.current.value = formattedDate;
                onDateSelect(selectedDates, formattedDate, instance)
            }
        }
        flatpickr(inputRef?.current, options);
        const initialFormattedDate = moment(defaultValue).format('lll');
        inputRef.current.value = initialFormattedDate;
        return () => {
            if (inputRef?.current?._flatpickr) {
                inputRef?.current?._flatpickr.destroy();
            }
        }
    }, [onDateSelect, defaultValue])
    return (
        <Fragment>

            <Input top={"0px !important"} ref={inputRef} type='text' />
            {/* <Input value={defaultValue}></Input> */}
        </Fragment>
    )
}

export default DateTimePicker
